import Phaser from "phaser";

/**
 * Level 3 enemies: the small bug and the big beast, packed as tight aligned
 * crawl strips by tools/pack-enemy.mjs. Texture key === logical key; each has one
 * looping crawl animation. Frame sizes come from the packer's output.
 */
export const ENEMY = {
  bug: { key: "bug", frames: 6, fw: 128, fh: 63, anim: "bug-crawl", rate: 10 },
  beast: { key: "beast", frames: 31, fw: 128, fh: 69, anim: "beast-crawl", rate: 14 },
} as const;

export type EnemyKey = keyof typeof ENEMY;

export function loadEnemies(scene: Phaser.Scene) {
  for (const e of Object.values(ENEMY)) {
    scene.load.spritesheet(e.key, `assets/sprites/${e.key}.png`, { frameWidth: e.fw, frameHeight: e.fh });
  }
}

export function registerEnemyAnims(scene: Phaser.Scene) {
  for (const e of Object.values(ENEMY)) {
    if (scene.anims.exists(e.anim)) continue;
    scene.anims.create({
      key: e.anim,
      frames: scene.anims.generateFrameNumbers(e.key, { start: 0, end: e.frames - 1 }),
      frameRate: e.rate,
      repeat: -1,
    });
  }
}
